import React from "react";
import AppShell from "./AppShell";
import { useShopMode } from "../../context/ShopModeContext";

export default function ShopShell({ children }) {
  const { mode } = useShopMode();                // garment | web3
  const isGarment = mode === "garment";

  return (
    <AppShell
      /* mobile theme */
      bottomTheme={isGarment ? "light" : "dark"}
      /* desktop frame + nav theme */
      sideTheme={isGarment ? "light" : "dark"}
      /* растягиваем контент на всю рабочую зону */
      innerFactor={0.9}
      /* solid black background inside on Web3 */
      contentVariant={isGarment ? "default" : "darkSolid"}
      disableMobileBottomPadding
    >
      {children}
    </AppShell>
  );
}
